/** @jsxImportSource @emotion/react */
'use client'

import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import type React from 'react'
import { FlexCol } from '../../layout'
import { styles } from './styles'

export interface OtpFormProps {
  otpCode: string
  onOtpChange: (value: string) => void
  onSubmit: () => void
  onBack: () => void
  otpError: string | null
  isLoading: boolean
}

export default function OtpForm({
  otpCode,
  onOtpChange,
  onSubmit,
  onBack,
  otpError,
  isLoading,
}: OtpFormProps) {
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    onSubmit()
  }

  return (
    <form onSubmit={handleSubmit} noValidate>
      <FlexCol gap="lg">
        <FlexCol gap="xs">
          <Typography
            variant="h1"
            component="h1"
            align="center"
            css={styles.headingFont}
          >
            Enter your code
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center">
            We&apos;ve sent a one-time passcode to your email. Enter it below to
            continue.
          </Typography>
        </FlexCol>

        <FlexCol gap="md">
          <TextField
            id="otp_code"
            label="OTP Code"
            fullWidth
            variant="outlined"
            autoComplete="one-time-code"
            inputMode="numeric"
            value={otpCode}
            onChange={(event) => onOtpChange(event.target.value)}
          />

          {otpError && (
            <Typography role="alert" color="error" variant="body2">
              {otpError}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
          >
            Submit OTP
          </Button>
          <Button type="button" variant="text" onClick={onBack}>
            Back to login
          </Button>
        </FlexCol>
      </FlexCol>
    </form>
  )
}
